module.exports = __webpack_public_path__ + "static/media/cross.31d5faa3.svg";